import { api } from "./axiosInstance";

export type OpportunityCategory = {
  id: string;
  name: string;
  sort_order: number;
};

export type Opportunity = {
  id: string;
  category_id: string;
  first_us_date: string | null;  // ISO date string
  artist_tour: string;
  ld: string;
  previous_tour_ld: string;
  christie_rep_ld: string;
  production_manager: string;
  previous_tour_pm: string;
  christie_rep_pm: string;
  band_management: string;
  location: string;
  agency: string;
  producer: string;
};

export type CreateOpportunityPayload = Omit<Opportunity, "id">;
export type UpdateOpportunityPayload = Omit<Opportunity, "id" | "category_id">;

export const apiGetOpportunityCategories = async (): Promise<OpportunityCategory[]> => {
  const response = await api.get("/api/opportunity-category");
  return response.data;
};

export const apiGetOpportunities = async (categoryId: string): Promise<Opportunity[]> => {
  const response = await api.get("/api/opportunity", { params: { categoryId } });
  return response.data;
};

export const apiCreateOpportunity = async (payload: CreateOpportunityPayload): Promise<Opportunity> => {
  const response = await api.post("/api/opportunity", payload);
  return response.data;
};

export const apiUpdateOpportunity = async (id: string, payload: UpdateOpportunityPayload): Promise<void> => {
  await api.patch(`/api/opportunity/${id}`, payload);
};

export const apiDeleteOpportunity = async (id: string): Promise<void> => {
  await api.delete(`/api/opportunity/${id}`);
};
